import mutations from './workspace.mutations'
import state from './workspace.state'

export default {
  mutations,
  state
}
